import { useMe } from '../../../../modules/Auth/hooks/useMe';
import { BrainLoadingIcon } from 'morpheus-ui';
import { Typography } from '../../molecules/Typography';

export const AuthenticatedLayout = ({ children, redirectOnFail = true }: any) => {
  const { isLoading } = useMe(redirectOnFail);

  if (isLoading) {
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center gap-md">
        <BrainLoadingIcon className="h-32 w-32 animate-pulse stroke-brand-color-primary-pure stroke-2" />
        <Typography className="text-brand-color-primary-pure">
          Transmitindo impulsos nervosos...
        </Typography>
      </div>
    );
  }

  return children;
};